export default "__VITE_ASSET__DoEqjFc5__"